import { sessaoFetchLoading } from '@/service/fetch'

export async function buscar (registro) {
  return sessaoFetchLoading(`consig`, `/entidades/buscarcadastral/${registro}`)
}

export async function consultar (tipo, registro) {
  return sessaoFetchLoading(`consig`, `/entidades/consultarcadastral/${tipo}/${registro}`, 'PATCH')
}



// WEBPACK FOOTER //
// ./src/api/cadastral.js